// getUrlParam
// - 2025.07.09
function getUrlParam (name) {
  const searchParams = new URLSearchParams(window.location.search)

  return searchParams.get(name)
}

// getMiniProgramContext
export function getMiniProgramContext () {
  // const appStore = useApplicationStore()

  // if (!appStore.wechat) {
  //   return false
  // }

  const context = {
    appKey: getUrlParam('qt_mp_appkey'),
    openId: getUrlParam('qt_mp_openid'),
    unionId: getUrlParam('qt_mp_unionid'),
    userId: getUrlParam('qt_mp_userid'),
    uuid: getUrlParam('qt_mp_uuid'),
    isClueCustomer: getUrlParam('qt_mp_is_clue_customer'),
  }

  return context
}

// initializeQuickTracking
// - 2025.07.09
export function initializeQuickTracking (defaultConfig = {
  appKey: import.meta.env.VUE_QUICK_TRACKING_APP_KEY,
  trackDomain: import.meta.env.VUE_QUICK_TRACKING_TRACK_DOMAIN,
}) {
  const mpContext = getMiniProgramContext()

  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['appKey', defaultConfig.appKey],
  })

  // Set track domain (same for both contexts)
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['trackDomain', defaultConfig.trackDomain],
  })

  console.log('mpContext', mpContext)

  if (
    mpContext
    && mpContext.openId
    && mpContext.unionId
    && mpContext.userId
    && mpContext.uuid
  ) {

    // _dev_id
    // - 设备 ID
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_dev_id', mpContext.openId],
    })

    // openid
    // - Wechat Open Id
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['openid', mpContext.openId],
    })

    // _user_id
    // - User ID
    if (mpContext.userId) {
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['_user_id', mpContext.userId],
      })
    }

    console.log('mpContext.isClueCustomer', mpContext.isClueCustomer)
    console.log('Boolean(mpContext.isClueCustomer)', Boolean(mpContext.isClueCustomer))

    // Append `globalproperty`
    // - 2025.07.10
    // - Append: user_uc_id, user_uuid, user_open_id, user_union_id
    // - 2025.07.11
    // - Append: user_is_clue_customer
    aplus_queue.push({
      action: 'aplus.appendMetaInfo',
      arguments: ['globalproperty', {
        user_uc_id: mpContext.userId,
        user_uuid: mpContext.uuid,
        user_open_id: mpContext.openId,
        user_union_id: mpContext.unionId,
        user_is_clue_customer: Boolean(mpContext.isClueCustomer),
      }],
    })

    // Record user profile
    // - 2025.07.11
    // - Append: user_is_clue_customer
    aplus_queue.push({
      action: 'aplus.record',
      arguments: ['$$_user_profile', 'OTHER', {
        user_uc_id: mpContext.userId,
        user_uuid: mpContext.uuid,
        user_open_id: mpContext.openId,
        user_union_id: mpContext.unionId,
        user_is_clue_customer: Boolean(mpContext.isClueCustomer),
      }],
    })
  }
}

